import { AlpineComponent } from 'alpinejs';

const Video = (): AlpineComponent => ({
  isPlaying: false,
  onClickPlay() {
    this.isPlaying = true;
    if (this.$refs.video) this.$refs.video.play();
  }
});

export default Video;
